import { render } from "./ToggleControl.vue?vue&type=template&id=c968debe&scoped=true"
import script from "./ToggleControl.vue?vue&type=script&lang=js"
export * from "./ToggleControl.vue?vue&type=script&lang=js"

import "./ToggleControl.vue?vue&type=style&index=0&id=c968debe&scoped=true&lang=css"

import exportComponent from "C:\\Deployment\\Member Portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c968debe"]])

export default __exports__